import { render, staticRenderFns } from "./PrivacyButton.vue?vue&type=template&id=6b582754&scoped=true"
import script from "./PrivacyButton.vue?vue&type=script&lang=js"
export * from "./PrivacyButton.vue?vue&type=script&lang=js"
import style0 from "./PrivacyButton.vue?vue&type=style&index=0&id=6b582754&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b582754",
  null
  
)

export default component.exports